import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import { useDispatch } from "react-redux";
import { edit as editSupplier } from "../redux/suppliers";
import { formatDateTime, getUserFullName } from "../utils";
import RowDetailField from "./RowDetailField";

const SupplierRow = (props) => {
  const dispatch = useDispatch();

  const { supplier } = props;
  const savedAt = formatDateTime(supplier.savedAt);
  const savedBy = getUserFullName(supplier.savedBy);

  const onEditClick = (event) => {
    event.stopPropagation();
    dispatch(editSupplier({ id: supplier.id, isNew: false }));
  };

  return (
    <Accordion
      className={props.className}
      disableGutters
      elevation={0}
      square
      TransitionProps={{ unmountOnExit: true }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon
            sx={{ visibility: { xs: "visible", sm: "hidden" } }}
          />
        }
      >
        <Grid container xs={12} spacing={1}>
          <Grid xs={1} sm={0.5}>
            {props.canEdit && (
              <IconButton aria-label="edit" onClick={onEditClick}>
                <EditIcon />
              </IconButton>
            )}
          </Grid>
          <Grid xs={11} sm={5.5} md={6.5}>
            {supplier.name}
          </Grid>
          <Grid display={{ xs: "none", sm: "block" }} sm={3} md={2.5}>
            {savedAt}
          </Grid>
          <Grid display={{ xs: "none", sm: "block" }} sm={3} md={2.5}>
            {savedBy}
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails sx={{ display: { xs: "block", sm: "none" } }}>
        <Grid container className="detailsContainer" xs={12} spacing={1}>
          <RowDetailField
            display={{ sm: "none" }}
            label="Saved At"
            value={savedAt}
          />
          <RowDetailField
            display={{ sm: "none" }}
            label="Saved By"
            value={savedBy}
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default styled(SupplierRow)(
  ({ theme }) => `
  &:hover {
    background-image:
      repeating-linear-gradient(90deg, ${theme.palette.secondary.main}, ${
        theme.palette.secondary.main
      } 1px, transparent 1px, transparent 2px, ${theme.palette.secondary.main} 2px),
      repeating-linear-gradient(90deg, ${theme.palette.secondary.main}, ${
        theme.palette.secondary.main
      } 1px, transparent 1px, transparent 2px, ${theme.palette.secondary.main} 2px);
    background-size: 100% 1px;
    background-position: 0 0, 0 100%;
    background-repeat: no-repeat;
  }

  ${theme.breakpoints.down("md")} {
    &.Mui-expanded {
      background-image: repeating-linear-gradient(90deg, ${
        theme.palette.background.paper
      }, ${
        theme.palette.background.paper
      } 1px, transparent 1px, transparent 2px, ${
        theme.palette.background.paper
      } 2px),
      linear-gradient(90deg, ${theme.palette.secondary.main} 30%, ${
        theme.palette.primary.main
      } 95%),
      repeating-linear-gradient(90deg, ${theme.palette.background.paper}, ${
        theme.palette.background.paper
      } 1px, transparent 1px, transparent 2px, ${
        theme.palette.background.paper
      } 2px),
      linear-gradient(90deg, ${theme.palette.secondary.main} 30%, ${
        theme.palette.primary.main
      } 95%);
      background-size: 100% 1px;
      background-position: 0 0, 0 0, 0 100%, 0 100%;
      background-repeat: no-repeat;
    }
  }

  .detailsContainer {
    overflow: hidden;
  }

  .MuiIconButton-root {
    padding: 0;
  }

  .MuiIconButton-root .MuiSvgIcon-root {
    font-size: 22px;
  }
`,
);
